// @generated by protoc-gen-es v1.10.0
// @generated from file ai/h2o/mlops/storage/v1/registered_model_service.proto (package ai.h2o.storage, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { FieldMask, proto3 } from "@bufbuild/protobuf";
import { RegisteredModel } from "./registered_model_pb.js";
import { FilterRequest, PagingRequest, PagingResponse, SortingRequest } from "./listing_pb.js";

/**
 * @generated from message ai.h2o.storage.CreateRegisteredModelResponse
 */
export const CreateRegisteredModelResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.CreateRegisteredModelResponse",
  () => [
    { no: 1, name: "registered_model", kind: "message", T: RegisteredModel },
  ],
);

/**
 * @generated from message ai.h2o.storage.GetRegisteredModelResponse
 */
export const GetRegisteredModelResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.GetRegisteredModelResponse",
  () => [
    { no: 1, name: "registered_model", kind: "message", T: RegisteredModel },
  ],
);

/**
 * @generated from message ai.h2o.storage.UpdateRegisteredModelResponse
 */
export const UpdateRegisteredModelResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.UpdateRegisteredModelResponse",
  () => [
    { no: 1, name: "registered_model", kind: "message", T: RegisteredModel },
  ],
);

/**
 * @generated from message ai.h2o.storage.ListRegisteredModelsRequest
 */
export const ListRegisteredModelsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.ListRegisteredModelsRequest",
  () => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "paging", kind: "message", T: PagingRequest },
    { no: 3, name: "filter", kind: "message", T: FilterRequest },
    { no: 4, name: "sorting", kind: "message", T: SortingRequest },
  ],
);

/**
 * @generated from message ai.h2o.storage.GetRegisteredModelRequest
 */
export const GetRegisteredModelRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.GetRegisteredModelRequest",
  () => [
    { no: 1, name: "model_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.CreateRegisteredModelRequest
 */
export const CreateRegisteredModelRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.CreateRegisteredModelRequest",
  () => [
    { no: 1, name: "registered_model", kind: "message", T: RegisteredModel },
  ],
);

/**
 * @generated from message ai.h2o.storage.ListRegisteredModelsResponse
 */
export const ListRegisteredModelsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.ListRegisteredModelsResponse",
  () => [
    { no: 1, name: "registered_models", kind: "message", T: RegisteredModel, repeated: true },
    { no: 2, name: "paging", kind: "message", T: PagingResponse },
  ],
);

/**
 * @generated from message ai.h2o.storage.UpdateRegisteredModelRequest
 */
export const UpdateRegisteredModelRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.UpdateRegisteredModelRequest",
  () => [
    { no: 1, name: "registered_model", kind: "message", T: RegisteredModel },
    { no: 2, name: "update_mask", kind: "message", T: FieldMask },
  ],
);

/**
 * @generated from message ai.h2o.storage.DeleteRegisteredModelRequest
 */
export const DeleteRegisteredModelRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.DeleteRegisteredModelRequest",
  () => [
    { no: 1, name: "model_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.DeleteRegisteredModelResponse
 */
export const DeleteRegisteredModelResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.DeleteRegisteredModelResponse",
  () => [
    { no: 1, name: "model_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.BatchDeleteRegisteredModelRequest
 */
export const BatchDeleteRegisteredModelRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.BatchDeleteRegisteredModelRequest",
  () => [
    { no: 1, name: "model_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message ai.h2o.storage.BatchDeleteRegisteredModelResponse
 */
export const BatchDeleteRegisteredModelResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.BatchDeleteRegisteredModelResponse",
  () => [
    { no: 1, name: "delete_registered_model_response", kind: "message", T: DeleteRegisteredModelResponse, repeated: true },
  ],
);

/**
 * @generated from message ai.h2o.storage.CountRegisteredModelRequest
 */
export const CountRegisteredModelRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.CountRegisteredModelRequest",
  () => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.CountRegisteredModelResponse
 */
export const CountRegisteredModelResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.CountRegisteredModelResponse",
  () => [
    { no: 1, name: "registered_model_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.GetRegisteredModelByNameRequest
 */
export const GetRegisteredModelByNameRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.GetRegisteredModelByNameRequest",
  () => [
    { no: 1, name: "model_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.GetRegisteredModelByNameResponse
 */
export const GetRegisteredModelByNameResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.GetRegisteredModelByNameResponse",
  () => [
    { no: 1, name: "registered_model", kind: "message", T: RegisteredModel },
  ],
);

